import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_DELIVERY_POINTS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/delivery-points`;

export const ADMIN_DELIVERY_POINTS_API_PATHS = {
  GET_DELIVERY_POINTS: `${ADMIN_DELIVERY_POINTS_API_ROOT}`,
  CREATE_DELIVERY_POINT: `${ADMIN_DELIVERY_POINTS_API_ROOT}`,
  GET_DELIVERY_POINT_BY_ID: (deliveryPointId: string) => `${ADMIN_DELIVERY_POINTS_API_ROOT}/${deliveryPointId}`,
  UPDATE_DELIVERY_POINT: (deliveryPointId: string) => `${ADMIN_DELIVERY_POINTS_API_ROOT}/${deliveryPointId}`,
  ARCHIVE_DELIVERY_POINT: (deliveryPointId: string) => `${ADMIN_DELIVERY_POINTS_API_ROOT}/${deliveryPointId}`,
  RESTORE_DELIVERY_POINT: (deliveryPointId: string) => `${ADMIN_DELIVERY_POINTS_API_ROOT}/${deliveryPointId}/restore`,
  GET_DELIVERY_DAYS: (deliveryPointId: string) => `${ADMIN_DELIVERY_POINTS_API_ROOT}/${deliveryPointId}/delivery-days`,
};
